const ROME_TIME_ZONE = 'Europe/Rome'
const Q4_START_MONTH = 10
const Q4_END_MONTH = 12

const readRomeCalendarPart = (date, partType) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: ROME_TIME_ZONE,
        year: 'numeric',
        month: 'numeric',
    }).formatToParts(date)

    const matchingPart = parts.find((part) => part.type === partType)

    return Number(matchingPart?.value)
}

export function getSubscriptionPromoContext(date = new Date()) {
    const currentYear = readRomeCalendarPart(date, 'year')
    const month = readRomeCalendarPart(date, 'month')
    const isQ4Promo = month >= Q4_START_MONTH && month <= Q4_END_MONTH

    return {
        isQ4Promo,
        currentYear,
        nextYear: currentYear + 1,
    }
}
